import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ConversationViewOptions {
  tooltip: string;
  value: string;
  text: string;
}
@Component({
  selector: 'phoenix-button-toggle',
  template: `
    <mat-button-toggle-group
      [value]="toggleValue"
      [hideSingleSelectionIndicator]="true"
      name="fontStyle"
      aria-label="Font Style"
      (change)="toggleSelected($event.value)"
    >
      @for (option of options; track $index) {
        <mat-button-toggle
          [value]="option.value"
          [matTooltip]="option.tooltip"
          >{{ option.text }}</mat-button-toggle
        >
      }
    </mat-button-toggle-group>
  `,
  standalone: false,
})
export class ButtonToggleComponent implements OnInit {
  @Input() options: any;
  @Input() toggleValue = '';
  @Input() tooltip = '';

  @Output() valueChange = new EventEmitter<string>();

  ngOnInit(): void {
    this.toggleValue = this.options[0].value;
  }

  toggleSelected(selectedValue: string) {
    this.valueChange.emit(selectedValue);
  }
}
